export default {
	sec_10: {
		title: {
			one: '글로벌 결제 ',
			two: '처리',
		},
		desc: {
			one: '자노페이를 받아서 원하는 ',
			two: '나라에 맞게 출금 가능.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_02: {
		title: {
			one: '현재 환율에',
			two: '자동 적용',
		},
		desc: {
			one: '언제든지 원하는 시간에 출금.',
		},
		step: {
			one: {
				one: 'Access JP WOLRD Pay ',
				two: 'via PC or mobile.',
			},
			two: {
				one: 'Fill your wallet with assets',
			},
			three: {
				one: 'You can invest or buy /??',
				two: 'wherever you want!',
			},
		},
	},
	sec_11: {
		one: {
			title: {
				one: '자노페이 고객은 나라에',
				two: '상관없이 결제 가능합니다.',
			},
		},
		two: {
			title: {
				one: '암호화폐를 사용하는 이유',
			},
			desc: {
				one: '가장 좋은 이유는 환율의 개수만 보면 되기 때문입니다.',
			},
		},
	},
};
